import { WEB_RTC_Constants } from "./Constants";
import shoutUIComponent from "../../../model/shoutUIComponent";
import {videoContainerRender} from "../templates/renders/videoContainer";

interface TypeDef_VideoContainer extends shoutUIComponent {
    constants?: {};
    $app?: any;
    isCustomerCameraEnabled: () => boolean;
    isVideoEnabled: () => boolean;
    isVoiceOnlyCall: () => boolean;
    isReconnecting: () => boolean;
    showPreCallView: () => void;
    showVideoCallView: (...arg0:any[]) => void;
    endCall: () => void;
    getVideoCallView: () => void;
}

/**
 * Custom element which act as a container for video call
 * @type {{template, created(), tagName: string, onCancelClick(): void, onOkClick(): void}}
 */
// eslint-disable-next-line object-shorthand
const VideoContainer: TypeDef_VideoContainer = {
    tagName: "video-container-view",
    renderer: videoContainerRender,
    created(): void {
        this.container = this.el.firstElementChild;
    },
    isCustomerCameraEnabled(): boolean {
        return this.prop[WEB_RTC_Constants.ENABLED_CUSTOMER_CAMERA.toLowerCase()] === "true";
    },
    isVideoEnabled(): boolean {
        return this.prop.videoenabled === "true";
    },
    isVoiceOnlyCall(): boolean {
        return this.prop[WEB_RTC_Constants.ENABLED_VOICE_ONLY_CALL.toLowerCase()] === "true";
    },
    isReconnecting(): boolean {
        return this.prop.reconnect === "true";
    },
    showPreCallView(): void {
        const preCallInstructionView = document.createElement("pre-call-instructions-view");
        preCallInstructionView.setAttribute(WEB_RTC_Constants.ENABLED_CUSTOMER_CAMERA, this.isCustomerCameraEnabled());
        preCallInstructionView.setAttribute(WEB_RTC_Constants.ENABLED_VOICE_ONLY_CALL, this.isVoiceOnlyCall());
        this.container.appendChild(preCallInstructionView);
    },

    /**
     * Removes the child elements and injects Video Call Screen
     * @param {int} volLevel
     * @param {string} sinkID
     * @param {string} audioSrc
     * @param {string} videoSrc
     */
    showVideoCallView(volLevel: any, sinkID: any, audioSrc: any, videoSrc: any): void {
        while (this.container.firstChild) {
            this.container.removeChild(this.container.firstChild);
        }

        this.videoCallView = document.createElement("video-stream-view");
        this.videoCallView.setAttribute("videoenabled", this.isVideoEnabled());
        this.videoCallView.setAttribute(WEB_RTC_Constants.ENABLED_CUSTOMER_CAMERA, this.isCustomerCameraEnabled());
        this.videoCallView.setAttribute(WEB_RTC_Constants.ENABLED_VOICE_ONLY_CALL, this.isVoiceOnlyCall());
        this.videoCallView.setAttribute("reconnect", this.isReconnecting());

        if (volLevel) {
            this.videoCallView.setAttribute("volLevel", volLevel);
        }

        if (sinkID) {
            this.videoCallView.setAttribute("sinkId", sinkID);
        }

        if (audioSrc && audioSrc !== "default") {
            this.videoCallView.setAttribute("audioSrc", audioSrc);
        }

        if (videoSrc && videoSrc !== "default") {
            this.videoCallView.setAttribute("videoSrc", videoSrc);
        }

        this.container.appendChild(this.videoCallView);
    },

    /**
     * handling and passing to child element end call command
     */
    endCall(): void {
        this.videoCallView.endCall();
    },

    /**
     * return video call screen element
     * @return {HTMLVideoElement} returns HTMLVideoElement
     */
    getVideoCallView(): any {
        return this.videoCallView;
    },
};

/**
 * @export
 * @param   {CIApp} appInstance App instance
 * @return  {VideoContainer}    View instance
 */
export default (appInstance: any) => {
    VideoContainer.$app = appInstance;

    /**
     * @type {Object}
     */
    const constObj = {};
    VideoContainer.constants = constObj;
    return VideoContainer;
};
